import { ProjectHttpClient } from '../../common/services/httpClient';

const baseServicePath = (projectId) => `projects/${projectId}/sharepoint/pptx`;

export const getPowerPointFileList = async (projectId) => {
  const response = await ProjectHttpClient.get(baseServicePath(projectId));
  return response.data;
};

export const getPowerPointSlides = async (projectId, driveId, fileId) => {
  const url = `${baseServicePath(
    projectId
  )}/slides?driveId=${driveId}&fileId=${fileId}`;
  const response = await ProjectHttpClient.get(url);

  return response.data;
};
